import React, { useContext, useEffect, useRef, useState } from 'react'
import _, { set } from 'lodash'
import { ReactComponent as Arrow } from '../images/uparrow.svg'
import { ReactComponent as SeatIcon } from '../images/seaticon.svg'
import CurrentBooking from '../comps/flexbooking/CurrentBooking'
import {previousBookings} from '../comps/flexbooking/dummybookings'
import PreviousBooking from '../comps/flexbooking/PreviousBooking'
import { calculatePrice, maxSeats, timeSlots } from '../comps/flexbooking/flexprice'
import { AppContext } from '../context/AppContext'

//const prevBooking = previousBookings[3]

const BookTripFlextime = () => {

  const {setPrevPage, setNextPage} = useContext(AppContext)
  const [prevBooking, setPrevBooking] = useState(previousBookings[0])

  setPrevPage("/booktrip")
  setNextPage("/booktrip/summary")



  let timeIndicators = []

  const {setTripDetails, tripDetails, preBookedSeats, setPreBookedSeats} = useContext(AppContext)
  const [currentBooking, setCurrentBooking] = useState({
    startRow: 1,
    width: parseInt(tripDetails.travellers),
    height: 6,
  })
  const [bookedSeats, setBookedSeats] = useState([])

  let times = [...Array(timeSlots)].map((v, ind) => {
    const hour = ('' + (ind/2|0)).padStart(2, '0')
    const minutes = (ind % 2) ? '30' : '00'
    return { hour, minutes }
  })

  const calculatePreBookedSeats = () => {
    let seats = Array(timeSlots).fill(0)
    prevBooking.forEach(booking => {
      const startRow = booking.row - 1
      const endRow = startRow + booking.size

      for (let i = startRow; i < endRow; i++) {
        seats[i] = seats[i] + 1
      }
    })
    return seats
  }

  const calculateSeats = () => {
    let seats = Array(timeSlots).fill(0)
    prevBooking.forEach(booking => {
      const startRow = booking.row - 1
      const endRow = startRow + booking.size

      for (let i = startRow; i < endRow; i++) {
        seats[i] = seats[i] + 1
      }
    })
    const startRow = currentBooking.startRow -1
    const endRow = startRow+currentBooking.height

    for (let i = startRow; i < endRow; i++) {
      seats[i] = seats[i] + currentBooking.width
    }
    


    return seats
  }

  useEffect(() => {
    if (currentBooking.width != tripDetails.travellers) {
      setCurrentBooking(prev => ({...prev, width: parseInt(tripDetails.travellers)}))
    }
    if (tripDetails.date) {
      const dateValue = parseInt(tripDetails.date.replaceAll('-',''))
      console.log(tripDetails.date, dateValue)
      setPrevBooking(previousBookings[dateValue % previousBookings.length])
      const newSeats = calculateSeats()
      setPreBookedSeats(calculatePreBookedSeats())
      setBookedSeats(newSeats)
    }

  }, [tripDetails])

  useEffect(() => {
    const newSeats = calculateSeats()
    setPreBookedSeats(calculatePreBookedSeats())
    setBookedSeats(newSeats)

    const filteredSeats = newSeats
      .map(s => maxSeats-s)
      .filter((_,i) => i >= currentBooking.startRow-1 && i < (currentBooking.startRow + currentBooking.height-1))
      .filter(s => s >= 0)

    console.log(filteredSeats)
    const {priceFrom,priceTo,flexReduction,minSeatReduction} = calculatePrice(currentBooking.height, Math.min(...filteredSeats),Math.max(...filteredSeats))

    const depFromIndex = currentBooking.startRow-1
    const depToIndex = depFromIndex + currentBooking.height
    const arrFromIndex = depFromIndex + 2
    const arrToIndex = depToIndex + 2
    const depFrom = `${times[depFromIndex].hour}:${times[depFromIndex].minutes}`
    const depTo = `${times[depToIndex].hour}:${times[depToIndex].minutes}`
    const arrFrom = `${times[arrFromIndex].hour}:${times[arrFromIndex].minutes}`
    const arrTo = `${times[arrToIndex].hour}:${times[arrToIndex].minutes}`
    console.log(depFrom,depTo)

    setTripDetails(prev => ({...prev,
      priceFrom,priceTo,
      priceFlexRed:flexReduction, priceFillRed: minSeatReduction,
      depFrom, depTo, arrFrom, arrTo,
    }))

  }, [currentBooking])

  const [hideinfo, setHideFlexinfo] = useState(false);

  const hideFlexinfo = () => {
    if (hideinfo) {

    } else {
      setHideFlexinfo(true)
    }
  }
  
  return (
    <div id='flex-time' className='flex-time'>
      <div className={ hideinfo ? `flex-time-info hide` : `flex-time-info`}> 
          <h3>Th flexible time picker</h3>
          <p>We at Volta have revolitionized the way of travel. With our short distance electrical flights our aim is to always fly with as full planes as possible. 
            In this screen you see the existing bookings for your travel day. Use the <strong class="yellow">yellow box</strong> to select the time you are able to leave, the more flexible you are the less you pay on your ticket! Also if you try to fill a time where others already have booked (striped areas) your price reduction will be even more!</p>
            <button onClick={hideFlexinfo} className="button">Ok! Got it.</button>   
      </div>

      <div className='flex-grid' style={{ '--column-count': maxSeats , '--time-slots': timeSlots}} >
        <div className='grid-lines'>
          {[...Array(maxSeats)].map((_,i) => (
            <div className='line'></div>
          ))}
        </div>
        {times.map((t, i) => (
          <span style={{ gridRow: i + 1 }} className='time-ind indicator'>
            <span className='hour'>{t.hour}</span>
            <span className='minutes'>{t.minutes}</span>
          </span>
        ))}
        {prevBooking.map(((booking, i) => (
          <PreviousBooking info={booking} column={i + 2} />
        )))}
        <CurrentBooking info={currentBooking} setCurrentBooking={setCurrentBooking} maxSeats={maxSeats} />
        {bookedSeats.map((count, i) => (
          <span style={{ gridRow: i + 1, gridColumn: maxSeats + 2 }} className={'seat-ind indicator' + (maxSeats-count < 2 ? ' full' : '') + (maxSeats-count < 0 ? ' negative' : '')}>{maxSeats - count}</span>
        ))}
        {bookedSeats.map((count, i) => (maxSeats-count < 0) ? (
        <div style={{ gridRow: i + 1, gridColumn: `${maxSeats - currentBooking.width+2} / span ${currentBooking.width}` }} class='collision-block'></div>
          
        ) : (
          null
        ))}

      </div>
    </div>
  )
}



export default BookTripFlextime;